import { v4 as uuid } from "uuid";
import {Model} from "../../base/Model";
import {Collection} from "../../base/Collection";


export class WebsiteSettingsModel extends Model  {

    constructor(data = null) {
        super(data);
        
        if(data) {
            super.createModel(data);
        }
    }
}